import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import moment from "moment";
// Antd
import { Typography, Row, Col, Icon, Collapse, Tabs } from "antd";

// Formik
import { FastField, Formik } from "formik";

// Yup
import * as Yup from "yup";

// Component
import Button from "../../../../components/Buttons";
import Input from "../../../../components/Common/Input";
import typo, { MESSAGE } from "../../../../constants/dictionaries";
import Select from "../../../../components/Common/Select";
import message from "../../../../components/Messages";
import DateField from "../../../../components/Common/DateField"
import ValidatedText from "../../../../components/Common/ValidatedText";
import DoanhNghiepGroup from "../../../../components/BaoCao/DNXCP";
import TextArea from "../../../../components/Common/TextArea";
import FileDinhKemPlus from "../../../../components/ThongTinTNN/FileDinhKem/TablePlus"
import Table from "../../../../components/Table";
import NumberField from "../../../../components/Common/NumberField";
// Colors
import colors from "../../../../constants/colors";

// Styled components
import styles from "./Modal.module.scss";
import Api_tnn from "../../../../api/api.tnn";
import Helper from "../../../../helper/helper";
import Box from "../../../../components/Box";
import Api from "../../../../api";
import KetQuaQuanTrac from "../../../../components/BaoCaoDinhKy/KetQuaQuanTrac/Table";
import Constant from "../../../../constants/constant";
import Api_quantrac from "../../../../api/api.quantrac";
import DisplayFormikState from '../../../../components/Table/DisplayFormikState'
const { Text } = Typography;
const { TabPane } = Tabs;
const ControllerForm = styled.div`
  // border: 1px solid #c8ced3;
  border-radius: 5px;
  background: ${colors.white};
`;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const ControllerFile = styled.div`
  padding-top: 30px;
`;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
const dateFormat = 'DD/MM/YYYY';
// Validations for add user
const addOrEditSchema = Yup.object().shape({
  soQD: Yup.string().required(typo.cscore_input_Required),
  kyBaoCao: Yup.string().required(typo.cscore_input_Required),
  dotBaoCao: Yup.string().required(typo.cscore_input_Required),
  ten: Yup.string().required(typo.cscore_input_Required)
});

class BCDKModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {},
      dataQuyetDinh: [],
      dataDiemXaThai: [],
      thietLapMau: [],
      loaiGP: undefined,
      years: [],
      KQQT: [],
      danhgia: this.props.selectedRow ? this.props.selectedRow.ketQua_DanhGia ? this.props.selectedRow.ketQua_DanhGia : 2 : 2,
      fileList: this.props.selectedRow ? this.props.selectedRow.files_BCDK : undefined,
    };
  }

  componentDidMount() {
    const { isEdit, selectedRow, dulieu } = this.props
    this.getYears()
    if (isEdit || dulieu) {
      this.GetDTMs_By_DoanhNghiep(selectedRow.doanhNghiep_Id)
    }
  }
  getYears = () => {
    var c_year = new Date().getFullYear(); var years = []
    for (var i = c_year + 20; i >= 1975; i--) { years.push({ year: i }) }
    this.setState({ years: years })
  }
  updateFileDinhKems = (items) => {
    this.setState({
      fileList: items
    })
  }

  GetDTMs_By_DoanhNghiep = (iddoanhnghiep) => {
    const { user, isEdit, selectedRow, dulieu } = this.props;
    new Api_quantrac().GetDTMs_By_DoanhNghiep({ token: user.access_token, iddoanhnghiep: iddoanhnghiep, page: 0, size: 0 })
      .then(res => {
        if (isEdit) {
          this.setState({
            initialValues: {...selectedRow},
            KQQT: selectedRow.kqqT_LIST ? JSON.parse(selectedRow.kqqT_LIST) : [],
            dataQuyetDinh: res && res.data
          })
        } else {
          if (dulieu) {
            this.setState({
              initialValues: {
                ...selectedRow,
                thongTinChung_Id: selectedRow.id
              },
              KQQT: [],
            })
          }
          this.setState({ dataQuyetDinh: res && res.data })
        }
      })
      .catch((err) => message.error(err.message))
  };

  handleGP = (value) => {
    this.GetDTMs_By_DoanhNghiep(value)
  }
  handleUpdateKQQT = (item) => {
    for (let index = 0; index < item.length; index++) {
      if (item[index].ketqua_danhgia === 1) {
        this.setState({ danhgia: 1 })
        break
      } else if (item[index].ketqua_danhgia === 0 || item[index].ketqua_danhgia === null || item[index].ketqua_danhgia === undefined) {
        this.setState({ danhgia: 0 })
      } else {
        this.setState({ danhgia: 2 })
      }
    }
    this.setState({
      KQQT: item.map((e, idx) => ({ ...e, stt: idx + 1 }))
    })
  }

  render() {
    const {
      handleCloseModal,
      selectedRow,
      isEdit,
      handleAdd,
      user,
      mode, dulieu
    } = this.props;
    const { initialValues, dataQuyetDinh, years, fileList, KQQT, danhgia } = this.state
    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={addOrEditSchema}
          onSubmit={(values, actions) => {
            if (isEdit) {
              new Api_quantrac()
                .PutDTM_BaoCaoDinhKy({
                  token: this.props.user.access_token,
                  data: {
                    ...values,
                    files_BCDK: fileList,
                    ketQua_DanhGia: danhgia,
                    kqqT_LIST: JSON.stringify(KQQT),
                  },
                  id: selectedRow.id
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                  handleAdd();
                  actions.resetForm({});
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
            else {
              new Api_quantrac()
                .PostDTM_BaoCaoDinhKy({
                  token: this.props.user.access_token,
                  data: {
                    ...values,
                    id: 0,
                    files_BCDK: fileList,
                    ketQua_DanhGia: danhgia,
                    kqqT_LIST: JSON.stringify(KQQT),
                  },
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_ADD_SUCCESS);
                  handleAdd();
                  actions.resetForm({});
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
          }}
          render={({
            errors,
            handleSubmit,
            touched,
            dirty,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit} autoComplete="false">
              <ControllerForm>
                <Tabs type="card">
                  <TabPane tab={typo.cscore_common_info} key="1" forceRender={true}>

                    <Row>
                      <Col span={12}>
                        <ControllerInput>
                          <DoanhNghiepGroup
                            values={values}
                            setFieldValue={setFieldValue}
                            mode={isEdit ? "edit" : dulieu ? "edit" : "add"}
                            view={mode}
                            handleGP={this.handleGP}
                          />
                          <Select
                            placeholder={Helper.genSelectPL(typo.cscore_soQuyetDinh)}
                            label={typo.cscore_soQuyetDinh}
                            onChange={(value, name) => {
                              setFieldValue("soQD", name.props.children);
                              setFieldValue("thongTinChung_Id", value);
                              setFieldValue("ngayKy", Helper.getFieldValueFromID(value, dataQuyetDinh, "ngayKy"));
                              setFieldValue("duAn_Ten", Helper.getFieldValueFromID(value, dataQuyetDinh, "duAn_Ten"));
                            }}
                            dataSource={dataQuyetDinh}
                            width="100%"
                            name="soQD"
                            name_value="id"
                            defaultValue={values.thongTinChung_Id}
                            value={values.thongTinChung_Id}
                            disabled={isEdit ? true : false}
                          />
                          <DateField
                            format={dateFormat}
                            placeholder={Helper.genSelectPL(typo.cscore_ngayquyetdinh)}
                            label={typo.cscore_ngayquyetdinh}
                            onChange={value => { setFieldValue("ngayKy", value && value.format()) }}
                            defaultValue={values.ngayKy}
                            value={values.ngayKy ? moment(values.ngayKy) : null}
                            disabled={true}
                          />

                          <FastField name="duAn_Ten" render={({ field }) => (
                            <Input placeholder={typo.cscore_input_tenduan_ten} label={typo.cscore_input_tenduan_ten} disabled={true} mandatory={false} {...field} />)} />

                          <FastField name="ma" render={({ field }) => (
                            <Input placeholder={typo.cscore_maBaoCao} label={typo.cscore_maBaoCao} mandatory={false} {...field} />)} />
                          <FastField name="ten" render={({ field }) => (
                            <Input placeholder={typo.cscore_ten_quy_hoach} label={typo.cscore_ten_quy_hoach} {...field} />)} />


                        </ControllerInput>
                      </Col>
                      <Col span={12}>
                        <ControllerInput>
                          <NumberField
                            label={typo.cscore_dot_bao_cao}
                            placeholder={typo.cscore_dot_bao_cao}
                            id="dotBaoCao"
                            min={0}
                            onChange={value => setFieldValue("dotBaoCao", value)}
                            value={values.dotBaoCao}
                          />
                          <Select
                            dataSource={years}
                            defaultValue={values.kyBaoCao ? Number(values.kyBaoCao) : undefined}
                            onChange={(value) => { setFieldValue("kyBaoCao", value) }}
                            placeholder={typo.cscore_chonnam}
                            label={typo.cscore_namBaoCao}
                            width="100%"
                            name="year"
                            name_value="year"
                            key={values.kyBaoCao}
                          />
                          <FastField
                            name="noiDung"
                            render={({ field }) => <TextArea placeholder={typo.cscore_noiDungBaoCao} label={typo.cscore_noiDungBaoCao} mandatory={false} {...field} rows={2} />}
                          />
                          <FastField
                            name="ghiChu"
                            render={({ field }) => <TextArea placeholder={typo.cscore_note} label={typo.cscore_note} mandatory={false} {...field} rows={2} />}
                          />
                        </ControllerInput>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <ControllerFile>
                          <Box label={typo.cscore_fileDinhkem}>
                            <FileDinhKemPlus dataSource={fileList} updateDataSource={this.updateFileDinhKems} mode={mode} />
                          </Box>
                        </ControllerFile>
                      </Col>
                    </Row>
                  </TabPane>
                  {values.thongTinChung_Id &&
                    <TabPane tab={typo.cscore_ket_qua_QT} key="2">
                      <Box size="small">
                        <KetQuaQuanTrac mode={mode} dataSource={KQQT} handleUpdate={this.handleUpdateKQQT} idQuyetDinh={values.thongTinChung_Id} />
                      </Box>
                    </TabPane>
                  }

                </Tabs>
                <ControllerButton>
                  {mode !== 'view' &&
                    <button
                      className='ant-btn'
                      type="submit"
                    >
                      <Icon type="save" style={{ marginRight: "8px" }} />
                      {typo.cscore_submit}
                    </button>}
                  <Button
                    type="cancel"
                    className={styles.buttonMargin}
                    onClick={handleCloseModal}
                  >
                    <Icon type="arrow-right" />
                    {typo.cscore_exit}
                  </Button>
                </ControllerButton>
              </ControllerForm>
              {/* <DisplayFormikState values={values} errors={errors}/> */}
            </form>
          )}
        />
      </div>
    );
  }
}

BCDKModal.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default BCDKModal;
